import { put, call } from 'redux-saga/effects';

import waitFor from '../waitFor';

export default function* dispatchAndWait(action) {
  yield put(action);

  return yield call(waitFor, action);
}
